import React, { useState, useEffect, useRef } from 'react';

import ProductPage from '../product-page/ProductPage';

import './MenuPage.css';

import logoImage from './../../image/logo.svg';
import backImage from './../../image/image-3.jpg';
import menuImage from './../../image/product-photo.png';
import plusBtn from './../../image/plus-btn-menu.svg';
import minusBtn from './../../image/minus-btn-menu.svg';
import axios from 'axios';

const MenuPage = ({
    setCurrentPage,
    isShowNavigation,
    setIsShowNavigation,
    setIsShowProductCard,
    totalSum,
    setTotalSum,
    productCount,
    setProductCount,
    setSelectProduct,
    handleMinusClick,
    handlePlusClick,
}) => {
    const [buttonName, setButtonName] = useState(null);
    const [activeFirstItem, setActiveFirstItem] = useState(null);
    const [activeSecondItem, setActiveSecondItem] = useState(null);
    const [activeThirdItem, setActiveThirdItem] = useState(null);

    // категории для меню
    const [menuCategoriesList, setMenuCategoriesList] = useState(null);

    // подкатегории для меню
    const [menuSubCategoriesList, setMenuSubCategoriesList] = useState(null);
    const [menuSubCategorySecond, setMenuSubCategorySecond] = useState(null);
    const [menuSubCategoryThird, setMenuSubCategoryThird] = useState(null);

    // продукты меню
    const [menuItemsList, setMenuItemsList] = useState(null);

    // первая категория
    const prevFirstSubCategoryRef = useRef();
    const prevSecondSubCategoryRef = useRef();
    const prevThirdSubCategoryRef = useRef();

    useEffect(() => {
        console.log('menuSubCategoriesList: ', menuSubCategoriesList);
        console.log('menuSubCategorySecond: ', menuSubCategorySecond);
        console.log('menuSubCategoryThird: ', menuSubCategoryThird);
        console.log('prevFirstSubCategoryRef: ', prevFirstSubCategoryRef);
        console.log('prevSecondSubCategoryRef: ', prevSecondSubCategoryRef);
        console.log('prevThirdSubCategoryRef: ', prevThirdSubCategoryRef);
    }, [
        menuSubCategoriesList,
        menuSubCategorySecond,
        menuSubCategoryThird,
        prevFirstSubCategoryRef,
        prevSecondSubCategoryRef,
        prevThirdSubCategoryRef,
    ]);

    useEffect(() => {
        console.log('productCount: ', productCount);
        console.log('totalSum: ', totalSum);
    }, [productCount, totalSum]);
    // загрузка суммы корзины из localStorage
    useEffect(() => {
        const savedTotalSum = localStorage.getItem('totalSum');
        if (savedTotalSum) {
            setTotalSum(parseInt(savedTotalSum, 10));
        }
    }, []);

    // обновление суммы корзины в localStorage
    useEffect(() => {
        localStorage.setItem('totalSum', totalSum);
    }, [totalSum]);

    // загрузка данных из localStorage
    useEffect(() => {
        if (menuItemsList) {
            const quantities = {};
            menuItemsList.forEach((item) => {
                const productData = localStorage.getItem(`product_${item.id}`);
                if (productData) {
                    quantities[item.id] = JSON.parse(productData);
                }
            });
            setProductCount(quantities);
        }
    }, [menuItemsList]);

    // сброс списка меню
    useEffect(() => {
        if (isShowNavigation === true) {
            setMenuSubCategoriesList(null);
            setMenuSubCategorySecond(null);
            setMenuSubCategoryThird(null);
            setMenuItemsList(null);
            setActiveFirstItem(null);
            setActiveSecondItem(null);
            setActiveThirdItem(null);
            prevFirstSubCategoryRef.current = null;
            prevSecondSubCategoryRef.current = null;
            prevThirdSubCategoryRef.current = null;
        }
    }, [isShowNavigation]);

    // первая подкатегория
    useEffect(() => {
        if (
            menuSubCategoriesList &&
            menuSubCategoriesList.subCategory.length > 0
        ) {
            const firstSubCategory = menuSubCategoriesList.subCategory[0];
            if (prevFirstSubCategoryRef.current !== firstSubCategory.id) {
                handleFirstItemClick(
                    firstSubCategory.name,
                    firstSubCategory.id
                );
                prevFirstSubCategoryRef.current = firstSubCategory.id;
            }
        }
    }, [menuSubCategoriesList]);

    useEffect(() => {
        if (menuSubCategorySecond && menuSubCategorySecond.length > 0) {
            const firstSubCategory = menuSubCategorySecond[0];

            if (prevSecondSubCategoryRef.current !== firstSubCategory.id) {
                handleSecondItemClick(
                    firstSubCategory.name,
                    firstSubCategory.id
                );
                prevSecondSubCategoryRef.current = firstSubCategory.id;
            }
        }
    }, [menuSubCategorySecond]);

    useEffect(() => {
        if (menuSubCategoryThird && menuSubCategoryThird.length > 0) {
            const firstSubCategory = menuSubCategoryThird[0];

            if (prevThirdSubCategoryRef.current !== firstSubCategory.id) {
                handleThirdItemClick(
                    firstSubCategory.name,
                    firstSubCategory.id
                );
                prevThirdSubCategoryRef.current = firstSubCategory.id;
            }
        }
    }, [menuSubCategoryThird]);

    // скролл категорий
    useEffect(() => {
        const categoryContainer = document.querySelector('.menu__list_filter');
        if (categoryContainer) {
            const handleWheel = (event) => {
                if (event.deltaY !== 0) {
                    event.preventDefault();
                    categoryContainer.scrollBy({
                        left: event.deltaY * 3.5,
                        behavior: 'smooth',
                    });
                }
            };

            categoryContainer.addEventListener('wheel', handleWheel);
            return () =>
                categoryContainer.removeEventListener('wheel', handleWheel);
        }
    }, []);

    // загрузка категорий
    useEffect(() => {
        const loadingCategory = async () => {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/menu/categories',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                if (response.data.success) {
                    setMenuCategoriesList(response.data.result);
                    console.log('Категории: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения списка категорий ', error);
            }
        };

        loadingCategory();
    }, []);

    // загрузка подкатегорий и блюд
    const handleNavigationClick = async (name, id) => {
        if (menuCategoriesList) {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/menu/items',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            subCategoryId: id,
                        },
                    }
                );
                if (response.data.success) {
                    setIsShowNavigation(!isShowNavigation);
                    setButtonName(name);
                    setMenuSubCategoriesList(response.data.result);
                    console.log(
                        'Подкатегории и продукты: ',
                        response.data.result
                    );
                }
            } catch (error) {
                console.error('Ошибка получения подкатегорий меню ', error);
            }
        }
    };

    // свернуть меню
    const handleBackClick = () => {
        setIsShowNavigation(!isShowNavigation);
    };

    // загрузка блюд
    const handleFirstItemClick = async (name, id) => {
        prevSecondSubCategoryRef.current = null;
        prevThirdSubCategoryRef.current = null;
        setMenuSubCategoryThird(null);
        setMenuSubCategorySecond(null);
        setActiveFirstItem(name);
        if (menuSubCategoriesList) {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/menu/items',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            subCategoryId: id,
                        },
                    }
                );
                if (response.data.success) {
                    const updatedMenuSubCategoriesList = {
                        ...menuSubCategoriesList,
                        itemModels: response.data.result.itemModels,
                    };
                    setMenuSubCategoriesList(updatedMenuSubCategoriesList);

                    if (
                        response.data.result.subCategory &&
                        response.data.result.subCategory.length > 0
                    ) {
                        setMenuSubCategorySecond(
                            response.data.result.subCategory
                        );
                    } else {
                        setMenuSubCategorySecond(null);
                    }
                    console.log('Меню: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения списка меню ', error);
            }
        }
    };

    const handleSecondItemClick = async (name, id) => {
        prevThirdSubCategoryRef.current = null;
        setMenuSubCategoryThird(null);
        setActiveSecondItem(name);
        if (menuSubCategoriesList) {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/menu/items',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            subCategoryId: id,
                        },
                    }
                );
                if (response.data.success) {
                    const updatedMenuSubCategoriesList = {
                        ...menuSubCategoriesList,
                        itemModels: response.data.result.itemModels,
                    };
                    setMenuSubCategoriesList(updatedMenuSubCategoriesList);

                    if (
                        response.data.result.subCategory &&
                        response.data.result.subCategory.length > 0
                    ) {
                        setMenuSubCategoryThird(
                            response.data.result.subCategory
                        );
                    } else {
                        setMenuSubCategoryThird(null);
                    }
                    console.log('Меню: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения списка меню ', error);
            }
        }
    };

    const handleThirdItemClick = async (name, id) => {
        setActiveThirdItem(name);
        if (menuSubCategoriesList) {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/menu/items',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            subCategoryId: id,
                        },
                    }
                );
                if (response.data.success) {
                    const updatedMenuSubCategoriesList = {
                        ...menuSubCategoriesList,
                        itemModels: response.data.result.itemModels,
                    };
                    setMenuSubCategoriesList(updatedMenuSubCategoriesList);
                    console.log('Меню: ', response.data.result);
                }
            } catch (error) {
                console.error('Ошибка получения списка меню ', error);
            }
        }
    };

    // клик по продукту
    const handleProductClick = async (id) => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/main/product',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        productId: id,
                    },
                }
            );

            if (response.data.success) {
                setSelectProduct(response.data.result);
                setIsShowProductCard(true);
            }
        } catch (error) {
            console.error('Ошибка получения данных о блюде: ', error);
        }
    };

    // клик по корзине
    const handleCartClick = () => {
        setCurrentPage('CartPage');
    };

    return (
        <div className='menu__items_wrapper'>
            <div className='menu__wrapper'>
                <div className='menu__logo'>
                    <img src={logoImage} alt='Logo' />
                </div>
                <div className='menu__main_items'>
                    {isShowNavigation && (
                        <div className='menu__main_item_one'>
                            <div className='menu__main_btns'>
                                {menuCategoriesList &&
                                    menuCategoriesList.map((category) => (
                                        <button
                                            className='menu__main_btn'
                                            onClick={() =>
                                                handleNavigationClick(
                                                    category.name,
                                                    category.id
                                                )
                                            }
                                            key={category.id}
                                        >
                                            {category.name}
                                        </button>
                                    ))}
                            </div>
                            <div className='menu__main_image'>
                                <img src={backImage} />
                            </div>
                            <div className='menu__main_summ'>
                                <button onClick={handleCartClick}>
                                    <p className='menu__main_summ_title'>
                                        Корзина
                                    </p>
                                    <h3 className='menu__main_summ_count'>
                                        {totalSum}₽
                                    </h3>
                                </button>
                            </div>
                        </div>
                    )}
                    {!isShowNavigation && (
                        <div className='menu__list_items'>
                            <div className='menu__list_btns'>
                                <button
                                    className='menu__list_btn'
                                    onClick={handleBackClick}
                                >
                                    {buttonName}
                                </button>
                            </div>

                            <div className='menu__list_main'>
                                {menuSubCategoriesList &&
                                    menuSubCategoriesList.subCategory.length >
                                        0 && (
                                        <div
                                            className={`menu__list_filter ${
                                                menuSubCategorySecond !== null
                                                    ? 'add_filter'
                                                    : ''
                                            }`}
                                        >
                                            {menuSubCategoriesList.subCategory.map(
                                                (subcategory) => (
                                                    <div
                                                        key={subcategory.id}
                                                        className={`menu__list_item ${
                                                            activeFirstItem ===
                                                            subcategory.name
                                                                ? 'active'
                                                                : ''
                                                        }`}
                                                        onClick={() =>
                                                            handleFirstItemClick(
                                                                subcategory.name,
                                                                subcategory.id
                                                            )
                                                        }
                                                    >
                                                        {subcategory.name}
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    )}

                                {menuSubCategorySecond && (
                                    <div
                                        className={`menu__list_filter ${
                                            menuSubCategoryThird !== null
                                                ? 'add_filter'
                                                : ''
                                        }`}
                                    >
                                        {menuSubCategorySecond.map(
                                            (subcategory) => (
                                                <div
                                                    key={subcategory.id}
                                                    className={`menu__list_item ${
                                                        activeSecondItem ===
                                                        subcategory.name
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        handleSecondItemClick(
                                                            subcategory.name,
                                                            subcategory.id
                                                        )
                                                    }
                                                >
                                                    {subcategory.name}
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}

                                {menuSubCategoryThird && (
                                    <div className='menu__list_filter'>
                                        {menuSubCategoryThird.map(
                                            (subcategory) => (
                                                <div
                                                    key={subcategory.id}
                                                    className={`menu__list_item ${
                                                        activeThirdItem ===
                                                        subcategory.name
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        handleThirdItemClick(
                                                            subcategory.name,
                                                            subcategory.id
                                                        )
                                                    }
                                                >
                                                    {subcategory.name}
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                                {menuSubCategoriesList &&
                                    menuSubCategoriesList.itemModels.length >
                                        0 && (
                                        <div
                                            className={`menu__list_product ${
                                                menuSubCategoriesList
                                                    .subCategory.length === 0
                                                    ? 'max-height'
                                                    : ''
                                            } ${
                                                menuSubCategorySecond !== null
                                                    ? 'min-height'
                                                    : ''
                                            } ${
                                                menuSubCategoryThird !== null
                                                    ? 'min-height-third'
                                                    : ''
                                            }`}
                                        >
                                            {menuSubCategoriesList.itemModels.map(
                                                (item) => (
                                                    <div
                                                        className='menu__list_product_item'
                                                        key={item.id}
                                                    >
                                                        <div className='menu__list_product_name'>
                                                            {item.name}
                                                        </div>
                                                        <div
                                                            className='menu__list_product_image'
                                                            onClick={() =>
                                                                handleProductClick(
                                                                    item.id
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    item.image
                                                                        ? `https://apihpwild.ru${item.image}`
                                                                        : menuImage
                                                                }
                                                                alt={item.name}
                                                            />
                                                        </div>
                                                        <div className='menu__list_product_count'>
                                                            <h3>
                                                                {item.price} ₽
                                                            </h3>
                                                            <div className='menu__list_product_count_btns'>
                                                                <button
                                                                    onClick={() =>
                                                                        handleMinusClick(
                                                                            item.id,
                                                                            item.price
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src={
                                                                            minusBtn
                                                                        }
                                                                    />
                                                                </button>
                                                                <p>
                                                                    {productCount[
                                                                        item.id
                                                                    ]
                                                                        ?.quantity ||
                                                                        0}
                                                                </p>
                                                                <button
                                                                    onClick={() =>
                                                                        handlePlusClick(
                                                                            item.id,
                                                                            item.name,
                                                                            item.price
                                                                        )
                                                                    }
                                                                >
                                                                    <img
                                                                        src={
                                                                            plusBtn
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    )}
                            </div>

                            <div className='menu__main_summ'>
                                <button onClick={handleCartClick}>
                                    <p className='menu__main_summ_title'>
                                        Корзина
                                    </p>
                                    <h3 className='menu__main_summ_count'>
                                        {totalSum}₽
                                    </h3>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MenuPage;
